/* eslint-disable vue/require-prop-types */
<!-- Components for input tag    -->

<script>
export default {
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model

  props: {
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-default-prop

    // eslint-disable-next-line vue/require-prop-types

    // Only allow types that essentially just render text boxes.
  },
  data() {
    return {
      data: null,
    }
  },
}
</script>

<template>
  <div>
    <div
      v-if="options.info !== undefined"
      :class="$style.guideBoard"
      class="mt30 "
    >
      <span :class="$style.guideBoardIcon"></span>
      <p :class="$style.guideBoardText"><b>Note : </b> {{ options.info }}</p>
      <div class="clear"></div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

// Instruction message
.guideBoard {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 60px);
  padding: 15px;
  margin-left: -30px;
  background: #fff5f1;

  .guideBoardIcon {
    position: relative;
    float: left;
    width: 45px;
    height: 45px;
    margin-right: 10px;
    background: #b9d3fa;
    border-radius: 50px;

    &::after {
      position: absolute;
      top: 0;
      left: 1px;
      width: 72px;
      height: 72px;
      content: '';
      background: url('~@assets/images/icon.png') no-repeat;
      background-position: 0 0;
      transform: scale(0.61);
      transform-origin: 0 0;
    }
  }

  .guideBoardText {
    float: left;
    width: calc(100% - 55px);
    margin: 8px 0 0;
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 12px;
    line-height: 16px;
    color: #757b82;
  }
}
// Instruction message
</style>
